import { render } from "./EditResponsavel.vue?vue&type=template&id=0dcc265d&scoped=true"
import script from "./EditResponsavel.vue?vue&type=script&lang=js"
export * from "./EditResponsavel.vue?vue&type=script&lang=js"

import "./EditResponsavel.vue?vue&type=style&index=0&id=0dcc265d&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/central-front/central-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dcc265d"]])

export default __exports__